module.exports = __webpack_public_path__ + "static/media/charitable.4e823c39.jpg";